<ng-template #chipsRow>
  @if (chips().length > 0) {
    <div class="flex flex-wrap gap-2 pt-3">
      @for (chip of chips(); track chip; let i = $index) {
        <app-chip
          [color]="chipColor()"
          [removable]="true"
          [bodyFocusable]="false"
          [removeAriaLabel]="'Remove ' + chip"
          [disabled]="isDisabled()"
          (removed)="removeChipAt(i)"
        >
          {{ chip }}
        </app-chip>
      }
    </div>
  }
</ng-template>

@if (chipsPosition() === 'above') {
  <ng-container *ngTemplateOutlet="chipsRow"></ng-container>
}

<app-input
  [label]="label() ?? ''"
  [placeholder]="placeholder() ?? ''"
  [helperText]="helperText() ?? ''"
  [required]="required()"
  [name]="name() ?? ''"
  [formControl]="inputControl"
  [trailingSlot]="hasCommittablePending()"
  (enterPressed)="onEnter()"
  (backspacePressed)="onBackspace($event)"
  (ionBlur)="onBlur()"
>
  @if (hasCommittablePending()) {
    <button
      appInputTrailing
      type="button"
      class="absolute right-2 top-1/2 z-10 flex -translate-y-1/2 items-center justify-center rounded-md p-1 text-primary hover:bg-surface-hover focus-visible:outline-none"
      [attr.aria-label]="'Add ' + trimmedPending()"
      (mousedown)="$event.preventDefault()"
      (click)="onEnter()"
    >
      <app-icon name="add-outline" size="md"></app-icon>
    </button>
  }
</app-input>

@if (hasPendingText()) {
  <div
    class="mt-2 flex items-center gap-1.5 rounded-lg border border-warning/40 bg-warning/10 px-3 py-1.5 text-xs text-body"
    aria-live="polite"
  >
    <app-icon name="alert-circle-outline" size="sm" color="warning"></app-icon>
    @if (pendingIsDuplicate()) {
      <span><span class="font-semibold">“{{ trimmedPending() }}”</span> is already in the list.</span>
    } @else if (atMaxChips()) {
      <span>Limit reached — remove one to add <span class="font-semibold">“{{ trimmedPending() }}”</span>.</span>
    } @else {
      <span><span class="font-semibold">“{{ trimmedPending() }}”</span> isn’t added yet — press Enter or tap +.</span>
    }
  </div>
}

@if (chipsPosition() === 'below') {
  <ng-container *ngTemplateOutlet="chipsRow"></ng-container>
}
